import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newBernConfig } from "./data";

export default function NewBernPage() {
  return <CityPageTemplate config={newBernConfig} />;
}